// removed by extract-text-webpack-plugin
module.exports = {"Wrapper":"Wrapper__2p7Nh"};


//////////////////
// WEBPACK FOOTER
// ./components/TextDisplay/style.scss
// module id = wDYE
// module chunks = 0